import { Box, Button, Modal } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CloseIconSvg from "../../../../../assets/images/CloseIconSVG";
import AsynSelect from "../../AsyncSelect/index";
import { closeSnackbar, openSnackbar } from "../../../../../features/snackbar/snackbarslice";
import { setArchiveProjectData, setProjectData } from "../../../../../features/product/projectSlice";
import "./AssignUserModal.css";
import { SNACKBAR_TYPES } from "../../../../../constants/constant";
import { clarityNav } from "../../../../../services/api/clarityNav/apiService";
import { startLoading, stopLoading } from "../../../../../features/loader/loaderSlice";


const AssignUserModal = ({
  openModal,
  setOpenModal,
  projectId,
  assigned,
  setAssigned,
  currentProjectOwner,
  currentusername,
}) => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state?.product?.users);
  //update collaborator api call function
  const [updateCollaborator] =clarityNav.useUpdateProjectCollaboratorMutation();
  //project data from redux(userProjectsData)
  const userProjectsData =useSelector((state) => state?.product?.projectsData) || [];
  const archiveProjectsData = useSelector((state) => state?.product?.archiveProjectsData) || [];
  // state for collaborator
  // const [setValue] = useState(assigned);
  // // update collaborator in state
  // const updateCollaboratorInRedux = (collaboratorsValue = []) => {
  //   setValue(collaboratorsValue.map((col) => col.value));
  // };

  const handleLoadOptions = async (inputValue) => {
    try {
      return options
        ?.filter((user) =>
          user?.email?.toLowerCase().includes(inputValue.toLowerCase())
        )
        .map((user) => ({
          label: user.email,
          value: user.user_id,
        }));
    } catch (error) {
      if (error?.response?.data?.data?.[0]) {
        dispatch(
          openSnackbar({
            message: error?.response?.data?.data?.[0] || "Something went wrong",
            type: SNACKBAR_TYPES.ERROR,
          })
        );
        setTimeout(() => {
          dispatch(closeSnackbar());
        }, 10000);
      } else {
        dispatch(
          openSnackbar({
            message: error.message || "Something went wrong",
            type: SNACKBAR_TYPES.ERROR,
          })
        );
        setTimeout(() => {
          dispatch(closeSnackbar());
        }, 10000);
      }
    }
  };

  const handleCloseModel = () => {
    setAssigned([]);
    setOpenModal(false);
  };

  const handleProjectAssign = async () => {
    try {
      dispatch(startLoading());
      const payload = {
        collaborators: assigned?.map((assignee) => ({ id: assignee?.value })),
      };
      const response = await updateCollaborator({
        projectId,
        data: payload,
      }).unwrap();
      const updatedProjectData = userProjectsData.map((project) => {
        if (project?.id === projectId) {
          return { ...project, collaborators: response?.result };
        }
        return project;
      });
      const updatedArchiveProjectData = archiveProjectsData?.map((project) => {
        if (project?.id === projectId) {
          return { ...project, collaborators: response?.result };
        }
        return project;
      });

      dispatch(setProjectData(updatedProjectData));
      dispatch(setArchiveProjectData(updatedArchiveProjectData))
      dispatch(stopLoading());
      dispatch(
        openSnackbar({
          message: "Collaborators are added",
          type: SNACKBAR_TYPES.SUCCESS,
        })
      );
      setTimeout(() => {
        dispatch(closeSnackbar());
      }, 10000);
      handleCloseModel();
      // dispatch(getProjectsStart());
    } catch (error) {
      if (error?.response?.data?.data?.[0]) {
        dispatch(
          openSnackbar({
            message: error?.response?.data?.data?.[0] || "Something went wrong",
            type: SNACKBAR_TYPES.ERROR,
          })
        );
        setTimeout(() => {
          dispatch(closeSnackbar());
        }, 10000);
      } else {
        dispatch(
          openSnackbar({
            message: error.message || "Something went wrong",
            type: SNACKBAR_TYPES.ERROR,
          })
        );
        setTimeout(() => {
          dispatch(closeSnackbar());
        }, 10000);
      }
    }
  };


  // useEffect(() => {
  //   if (assigned.length > 3) {
  //     setContentBgBoxHeight("232px");
  //     setContentBgBoxOverflow("auto");
  //   } else {
  //     let newHeight;
  //     switch (assigned.length) {
  //       case 1:
  //         newHeight = "108px";
  //         break;
  //       case 2:
  //         newHeight = "186px";
  //         break;
  //       case 3:
  //         newHeight = "232px";
  //         break;
  //       default:
  //         newHeight = "108px";
  //     }
  //     setContentBgBoxHeight(newHeight);
  //     setContentBgBoxOverflow("hidden");
  //   }
  // }, [assigned]);

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="fileUploadModal assignUserModal">
        <div className="file_header">
          <div className="attach">Assign project </div>
          <Button onClick={handleCloseModel} className="closeIconBtn mx-2">
            <CloseIconSvg fillColor="#ffffff" />
          </Button>
        </div>
        <div className="DropBox w-100 d-flex flex-column align-items-center justify-content-center p-4">
          <div className="contentBgBox">
            <h4 className="text-[14px]">Username/Email-ID</h4>
            <AsynSelect
              value={assigned}
              onChange={setAssigned}
              loadOptions={handleLoadOptions}
            />
          </div>
        </div>
        <div className="w-100 d-flex justify-content-end px-4 pt-2 pb-4 gap-[8px]">
          <Button onClick={handleCloseModel} className="close_btn w-[150px]">
            Cancel
          </Button>
          <Button
            onClick={handleProjectAssign}
            className="validate_btn_enabled w-[150px]"
            // disabled={currentusername !== currentProjectOwner}'
          >
            Assign project
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default AssignUserModal;
